import React from 'react';
import {
  Box,
  FormControl,
  Select,
  MenuItem,
} from '@mui/material';

interface CardFilterProps {
  value: 'daily' | 'weekly';
  onChange: (value: 'daily' | 'weekly') => void;
  loading?: boolean;
}

const CardFilter: React.FC<CardFilterProps> = ({
  value,
  onChange,
  loading = false,
}) => {
  const filterOptions = [
    { value: 'daily', label: 'Daily' },
    { value: 'weekly', label: 'Weekly' },
  ];

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <FormControl size="small" sx={{ minWidth: 100 }}>
        <Select
          value={value}
          onChange={(e) => onChange(e.target.value as 'daily' | 'weekly')}
          disabled={loading}
          sx={{ 
            '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
            '& .MuiSelect-select': { py: 0.5, px: 1 }
          }}
        >
          {filterOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default CardFilter;
